var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Dialog, IconButton, Tooltip, Typography } from '@mui/material';
import { ChevronLeft, ChevronRight, DoNotDisturb, FolderZip } from '@mui/icons-material';
import React, { useEffect, useMemo, useState } from 'react';
import { ShowContent } from './ShowContent';
import DOMPurify from 'dompurify';
var FileProps = /** @class */ (function () {
    function FileProps() {
    }
    return FileProps;
}());
export { FileProps };
export var FileView = function (_a) {
    //region Hooks
    var handlePrevView = _a.handlePrevView, handleNextView = _a.handleNextView, handleOnClose = _a.handleOnClose, _b = _a.indexView, indexView = _b === void 0 ? 0 : _b, _c = _a.maxIndex, maxIndex = _c === void 0 ? 0 : _c, _d = _a.open, open = _d === void 0 ? false : _d, fileProps = _a.fileProps, item = _a.item;
    useEffect(function () {
    }, [indexView, maxIndex, fileProps, item]);
    var _e = useState(false), zoom = _e[0], setZoom = _e[1];
    var isImage = useMemo(function () {
        var _a;
        return (_a = fileProps === null || fileProps === void 0 ? void 0 : fileProps.type) === null || _a === void 0 ? void 0 : _a.startsWith('image');
    }, [fileProps === null || fileProps === void 0 ? void 0 : fileProps.type]);
    var isPdf = useMemo(function () {
        var _a;
        return (_a = fileProps === null || fileProps === void 0 ? void 0 : fileProps.type) === null || _a === void 0 ? void 0 : _a.startsWith('application/pdf');
    }, [fileProps === null || fileProps === void 0 ? void 0 : fileProps.type]);
    var isTitleHtml = useMemo(function () {
        return !!item && !!(item === null || item === void 0 ? void 0 : item.descricao);
    }, [item]);
    var title = useMemo(function () {
        var _a;
        return ((item === null || item === void 0 ? void 0 : item.descricao) ? DOMPurify.sanitize((item === null || item === void 0 ? void 0 : item.descricao) || '') : (_a = fileProps === null || fileProps === void 0 ? void 0 : fileProps.name) !== null && _a !== void 0 ? _a : 'Visualização de Arquivo');
    }, [item === null || item === void 0 ? void 0 : item.descricao, fileProps === null || fileProps === void 0 ? void 0 : fileProps.name]);
    var minItem = useMemo(function () {
        return indexView === 0;
    }, [indexView]);
    var maxItem = useMemo(function () {
        return indexView === maxIndex;
    }, [indexView, maxIndex]);
    //endregion
    return (_jsxs(Dialog, __assign({ PaperProps: {
            sx: {
                backgroundColor: 'rgba(0, 0, 0, 0.60)',
                boxShadow: 'none',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '90vh',
                borderRadius: 1
            }
        }, onClose: handleOnClose, maxWidth: "lg", open: open, fullWidth: true }, { children: [_jsxs(Box, __assign({ sx: { width: '100%', textAlign: 'center', position: 'absolute', mb: 2, top: 20, zIndex: 11 } }, { children: [_jsx(ShowContent, __assign({ show: isTitleHtml }, { children: _jsx(Typography, { variant: "h6", fontWeight: "bold", color: 'white', dangerouslySetInnerHTML: { __html: title } }) })), _jsx(ShowContent, __assign({ show: !isTitleHtml }, { children: _jsx(Typography, __assign({ variant: "h6", fontWeight: "bold", color: 'white' }, { children: title })) }))] })), _jsx(Box, __assign({ sx: { position: 'absolute', top: '50%', left: 16, transform: 'translateY(-50%)', zIndex: 10 } }, { children: _jsx(Tooltip, __assign({ title: minItem ? 'Não há item anterior nesta seção' : '', componentsProps: {
                        tooltip: {
                            sx: {
                                fontSize: '12px',
                                padding: '8px 12px'
                            }
                        }
                    }, disableInteractive: true, placement: "left", arrow: true }, { children: _jsx("span", __assign({ style: { display: 'inline-flex' } }, { children: _jsx(IconButton, __assign({ sx: {
                                position: 'absolute',
                                top: '50%',
                                left: 16,
                                transform: 'translateY(-50%)',
                                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                ':hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)'
                                },
                                zIndex: 10,
                                pointerEvents: 'auto',
                                '&.Mui-disabled': {
                                    pointerEvents: 'auto',
                                    backgroundColor: 'rgba(255, 255, 255, 0.4)',
                                    color: 'inherit'
                                }
                            }, onClick: handlePrevView, disabled: minItem }, { children: _jsx(ChevronLeft, { fontSize: "large" }) })) })) })) })), _jsx(Box, __assign({ sx: { position: 'absolute', top: '50%', right: 16, transform: 'translateY(-50%)', zIndex: 10 } }, { children: _jsx(Tooltip, __assign({ title: maxItem ? 'Não há item posterior nesta seção' : '', componentsProps: {
                        tooltip: {
                            sx: {
                                fontSize: '12px',
                                padding: '8px 12px'
                            }
                        }
                    }, disableInteractive: true, placement: "right", arrow: true }, { children: _jsx("span", { children: _jsx(IconButton, __assign({ disabled: maxItem, sx: {
                                position: 'absolute',
                                top: '50%',
                                right: 16,
                                transform: 'translateY(-50%)',
                                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                ':hover': {
                                    backgroundColor: 'rgba(255, 255, 255, 0.9)'
                                },
                                zIndex: 10,
                                pointerEvents: 'auto',
                                '&.Mui-disabled': {
                                    pointerEvents: 'auto',
                                    backgroundColor: 'rgba(255, 255, 255, 0.4)',
                                    color: 'inherit'
                                }
                            }, onClick: handleNextView }, { children: _jsx(ChevronRight, { fontSize: "large" }) })) }) })) })), _jsx(Box, __assign({ sx: {
                    position: 'relative',
                    maxWidth: '70%',
                    width: '100%',
                    maxHeight: 'calc(90vh - 100px)',
                    p: 2,
                    borderRadius: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    overflowY: 'auto',
                    mt: 8
                } }, { children: _jsx(ShowContent, __assign({ show: !!(fileProps === null || fileProps === void 0 ? void 0 : fileProps.url) && !!(fileProps === null || fileProps === void 0 ? void 0 : fileProps.type) }, { children: _jsxs(_Fragment, { children: [_jsx(ShowContent, __assign({ show: isImage }, { children: _jsx("button", __assign({ onClick: function () { return setZoom(function (prev) { return !prev; }); }, style: {
                                        all: 'unset',
                                        cursor: zoom ? 'zoom-out' : 'zoom-in',
                                        transition: 'transform 0.3s ease',
                                        display: 'inline-block'
                                    } }, { children: _jsx("img", { style: {
                                            width: zoom ? 'auto' : '100%',
                                            height: 'auto',
                                            maxWidth: zoom ? 'none' : '100%',
                                            objectFit: zoom ? 'unset' : 'contain'
                                        }, src: fileProps === null || fileProps === void 0 ? void 0 : fileProps.url, alt: "Visualiza\u00E7\u00E3o" }) })) })), _jsx(ShowContent, __assign({ show: isPdf }, { children: _jsx("iframe", { src: fileProps === null || fileProps === void 0 ? void 0 : fileProps.url, title: "Documento PDF", style: { border: 'none', borderRadius: 4, width: '100%', height: '80vh' } }) })), _jsx(ShowContent, __assign({ show: !isImage && !isPdf }, { children: _jsxs(Box, __assign({ sx: {
                                        backgroundColor: 'rgba(255, 255, 255, 0.70)'
                                    }, flexDirection: 'column', alignItems: 'center', textAlign: 'center', borderRadius: 16, maxWidth: '70%', display: 'flex', paddingTop: 1, paddingX: 20, height: 300, gap: 2 }, { children: [_jsxs(Box, __assign({ sx: { position: 'relative', display: 'inline-block' } }, { children: [_jsx(FolderZip, { sx: { fontSize: 100, color: 'gray' } }), _jsx(DoNotDisturb, { sx: {
                                                        fontSize: 36,
                                                        position: 'absolute',
                                                        bottom: 0,
                                                        right: '29px',
                                                        backgroundColor: 'white',
                                                        borderRadius: '50%'
                                                    }, color: "error" })] })), _jsx(Typography, __assign({ color: "black", fontWeight: 'medium', fontSize: 20 }, { children: "N\u00E3o \u00E9 poss\u00EDvel visualizar arquivos compactados ou a Visualiza\u00E7\u00E3o n\u00E3o \u00E9 suportada para este tipo de arquivo." }))] })) }))] }) })) }))] })));
};
